import React, { useState, useEffect, useRef } from 'react';
// import styles from './styles.scss';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';

// review stub for testing for now
const max = 999;
const reviewsCount = Math.floor(Math.random() * max);
const randomRating = 4.5;
const maxRating = 5;
const reviewStub = {
  bestRating: 5,
  ratingValue: randomRating,
  reviewItems: [],
  reviewsCount,
  makeRating: () => Number(Math.random() * maxRating).toFixed(1),
  makeCount: () => Math.floor(Math.random() * max),
};

const appUrl = document.URL;
const IS_DEV_ENV =
  appUrl.includes('baseline') ||
  appUrl.includes('localhost') ||
  appUrl.includes('prouat');

// star and nbsp characters
const DEFAULT_FIVE_STARS_CONTENT = '★\u00a0★\u00a0★\u00a0★\u00a0★\u00a0';

export default function RatingStars(props) {
  const { t } = useTranslation();

  const {
    ratingContent = DEFAULT_FIVE_STARS_CONTENT,
    variant,
    review: incomingReview,
    isAvailable,
  } = props;
  let review = incomingReview;

  // if in dev, review stub for testing only for now)
  if (IS_DEV_ENV) {
    review = reviewStub;
    review.reviewsCount = review.makeCount();
    review.ratingValue = review.makeRating();
  }

  const { ratingValue, bestRating, reviewsCount } = review;
  const BUMP = variant === 'pdp' ? 3.5 : 2.5;

  const [width, setWidth] = useState();
  const ref = useRef(null);

  useEffect(() => {
    const clientWidth = ref.current.clientWidth;
    const starsWidth = Math.round(clientWidth * (ratingValue / bestRating));

    setWidth(starsWidth - BUMP);
  }, []);

  useEffect(() => {
    ref.current.style.width = `${width}px`;
  }, [width]);

  const reviewCountLabel =
    variant === 'pdp'
      ? `(${reviewsCount}  ${t('ratings_review_label')})`
      : reviewsCount;

  return (
    <div>
      <div
        className={`${styles.ratingsReview} ${
          variant === 'pdp' ? styles.ratingsReviewPdp : ''
        }`}
      >
        <div>
          {/* star rating value */}
          <div
            ref={ref}
            className={`${styles.rating} ${
              variant === 'pdp' ? styles.ratingPdp : ''
            }
              ${!isAvailable && styles.unavailable}`}
            data-rating-content={ratingContent}
          />

          {/* all stars underneath the star rating */}
          <div
            className={`${styles.ratingContent} ${
              variant === 'pdp' ? styles.ratingPdp : ''
            }`}
            data-rating-content={ratingContent}
          />
        </div>

        {variant !== 'plp' && (
          <span
            className={`${styles.ratingValue} ${
              !isAvailable && styles.unavailable
            }`}
          >
            {ratingValue}
          </span>
        )}

        <span
          className={`${styles.reviewsCount} ${
            variant === 'pdp' ? styles.reviewsCountPdp : ''
          } ${!isAvailable && styles.unavailable}`}
        >
          {reviewCountLabel}
        </span>
      </div>
    </div>
  );
}
